<template>

  <div class="menuHeight">

    <div class="menuContainer" id="menuContainer">
      <Logo class="visible"/>
      <div class="menu">
				<span class="link dropdownMenu mt-2" :class="{pointerEvent: isChangedEvent}"
              v-on:mouseleave="hideMenuFunction"
              id="checkpos"
              @click="$root.isStore=true"
              v-for="(Menu, i) in this.$root.menu"
              :key="i">
					<span class="menuBackground"
                :class="hideMenu  ? 'tempClass': ''"
          ></span>
					  <router-link
                @click.native.prevent="hideMenuHandler"
                class="dropdownChild"
                :to="'/category/' + Menu.menu_url_key + '.html'"
            >
              {{ removeAnd(Menu.name) }}
					</router-link>
          <!-- v-if="Menu.childs" -->
					<span class="subMenu newSubMenu"
                :class="hideMenu  ? 'tempClass': '' "
          >
					<div class="newUlDrop"
               :class="Menu.id_category == 8819 ? 'fashion': '' || Menu.id_category == 10396 ? 'beauty': '' || Menu.id_category == 10779 ? 'grocery': '' || Menu.id_category == 9341 ? 'electronics': '' || Menu.id_category == 10606 ? 'sports': ''  || Menu.id_category == 11775 ? 'books': '' || Menu.id_category == 9688 ? 'homeandliving': '' || Menu.id_category == 12039 ? 'pharmacy': '' || Menu.id_category == 11816 ? 'petcare': ''"
               v-if="Menu.childs">
						 <ul class="menuImage">
              <li class="subLink" v-for="(childs, h) in Menu.childs" :key="h">
                <router-link
                    @click.native.prevent="hideMenuHandlerN"
                    :to="'/category/' + childs.menu_url_key + '.html'">
                  {{ childs.name }}
                </router-link>
                <ul class="lastmenu" v-if="childs.childs">
                  <li class="lastLink" v-for="(sub, h) in childs.childs" :key="h">
                    <router-link
                        @click.native.prevent="hideMenuHandlerN"
                        :to="'/category/' + sub.menu_url_key + '.html'"
                        v-if="childs.landing_page == null"
                    >
                      {{ sub.name }}
                    </router-link>
                  </li>
                </ul>
              </li>
						</ul>

					<div class="menuImageRightSection">
						<span class="menuImageFashion">
							<div class="pr-2">
								<img src="/img/Fashion-1.jpg" class="img-fluid" alt="">
							</div>
							<div>
								<img src="/img/Fashion-2.jpg" class="img-fluid" alt="">
							</div>
						</span>
						<span class="menuImageBeauty">
							<div class="pr-2">
								<img src="/img/Beauty-1.jpg" class="img-fluid" alt="">
							</div>
							<div>
								<img src="/img/Beauty-2.jpg" class="img-fluid" alt="">
							</div>
						</span>
						<span class="menuImageElectronics">
							<div class="pr-2">
								<img src="/img/Electronics-1.jpg" class="img-fluid" alt="">
							</div>
						</span>
            <span class="menuImageHomeliving">
							<div class="pr-2">
								<img src="/img/livinghome.jpg" class="img-fluid" alt="">
							</div>
						</span>
            <span class="menuImagePharmacy">
							<div class="pr-2">
								<img src="/img/pharmacy.jpg" class="img-fluid" alt="">
							</div>
						</span>
            <span class="menuImagePetcare">
							<div class="pr-2">
								<img src="/img/petcaremenu.jpg" class="img-fluid" alt="">
							</div>
						</span>
            
						<span class="menuImageFood">
							<div class="pr-2">
								<img src="/img/foods-and-grocery-1.jpg" class="img-fluid" alt="">
							</div>
						</span>
						<span class="menuImageGift">
							<div class="pr-2">
								<img src="/img/Gift-1.jpg" class="img-fluid" alt="">
							</div>
						</span>
						<span class="menuImageSport">
							<div class="pr-2">
								<img src="/img/Sport-2.jpg" class="img-fluid" alt="">
							</div>
							<div>
								<img src="/img/Sport-1.jpg" class="img-fluid" alt="">
							</div>
						</span>
            <!-- <span class="menuImageSport">
							<div class="pr-2">
								<img src="/img/Sport-2.jpg" class="img-fluid" alt="">
							</div>
							<div>
								<img src="/img/Sport-1.jpg" class="img-fluid" alt="">
							</div>
						</span> -->
					</div>
					</div>
					</span>
				</span>

        <!-- <div class="location visible">
          <span>Noida</span>, Uttar Pradesh,India
          <span class="locationIcon"></span>
        </div> -->

        <!-- <div class="icons visible">
                <img src="/img/search.png" width="26"/>
                <img @click="toggleLogin" src="/img/user.png" width="26"/>
                <img src="/img/maps.png" width="26"/>

                <img src="/img/shopping-bag.png" width="26"/>
                <span class="badge">2</span>
                </div>  -->
        <!-- " -->
      </div>
      <!-- sticky store navigation  -->
      <div
          class="category newStoreSticky"
          v-if="this.$route.name == 'Home'"
          id="category"
      >
        <ul class="sortLink">
          <li
              class="link tagLinks"
              v-for="(item, i) in this.$root.nearestCategories"
              :key="i"
          >
            <a
                :class="{ 'router-link-active': i == sectionActive }"
                @click="sectionActive = i"
                :href="`#${item.id}`"
                :name="`${item.name}`"
                :data-id="item.id"
            >
              {{ item.name }}
            </a>
          </li>
          <li class="link tagLinks">
            <a href="#All" name="All" data-id="All"> All Stores</a>
          </li>
        </ul>
      </div>
      <div class="icons visible">
        <div
            title="Wishlist"
            class="mobile wishlist-icon iconWithBadge"
            v-if="this.$root.customer_id"
            @click="wishlist"
        >
          wishlist
          <span class="badge">{{ this.$root.wishListProducts }}</span>
        </div>
        <!-- <div class="desktop store-icon"> store
    </div> -->
        <div
            title="Cart"
            @click="minicart_show_hide"
            class="iconWithBadge cart-icon asdf"
        >
          cart
          <span class="badge" v-text="this.$root.cart_product.length"></span>
        </div>
      </div>

      <!-- <b-nav-item :to="'/collection/'+Menu.menu_url_key" v-else>{{Menu.name}}
      <ul class="dropdown-menu" v-if="Menu.childs">
      <li class="item" v-for="(childs,h) in Menu.childs">
      <router-link :to="'/category/'+childs.menu_url_key" v-if="childs.landing_page==null"></router-link>
      <router-link :to="'/collection/'+childs.menu_url_key" v-else></router-link>
      </li>
      </ul>
    </b-nav-item> -->
    </div>

    <!-- <div class="loginDetail" @click="closeLoginDetail" v-if="this.$root.login_detail">
  login
  </div> -->
    <div
        class="minicart"
        v-bind:class="[this.$root.minicart ? '' : 'minicartOverlay']"
        @click="minicart_show_hide"
    >
      <div
          class="minicart-content"
          v-if="this.$root.cart_product.length != 0"
          v-bind:class="[this.$root.minicart ? '' : 'active']"
      >
        <div class="block-content">
          <button
              type="button"
              class="action close"
              @click="this.$root.minicart = false"
          >
            <span class="fa fa-close"></span>
          </button>
          <div>
            <p class="w-50 pull-left">
              <span class="font-medium">Item in Cart : </span>
              <span v-text="this.$root.cart_product.length"></span>
            </p>
            <p class="w-50 pull-left ">
              <span class=" float-right ml-2"> {{ this.$root.cart_subtotal | formatMoney }}</span>
              <span class="font-medium float-right"> Subtotal : </span>
            </p>
          </div>
          <div class="actions">
            <!-- @click.native="checkout_gtm" -->
          </div>
          <ol class="minicart-items">
            <li v-for="(items, index) in this.$root.cart_product" :key="index">
              <div class="product">
                <router-link
                    :to="{
										name: 'detail',
										params: {
											pro_id: items.id_product,
											pro_url_key: items.url_key,
										},
										query: { store: items.store_id },
									}"
                    class="product-item-photo"
                >
                  <responsive-image

                      :alt="items.name"
                      :title="items.name"

                      v-bind:desktop="`${$root.image_url_c}inside/900x450/${items.image}`"
                      v-bind:tab="`${$root.image_url_c}inside/600x280/${items.image}`"
                      v-bind:mobile="`${$root.image_url_c}inside/650x280/${items.image}`"
                      v-bind:default_image="`${$root.image_url_c}inside/800x250/${items.image}`"


                  />


                </router-link>
                <div class="product-item-details">
                  <router-link
                      :to="{
											name: 'detail',
											params: {
												pro_id: items.id_product,
												pro_url_key: items.url_key,
											},
											query: { store: items.store_id },
										}"
                      class="font-medium"
                  >
                    {{ items.name }}
                  </router-link>
                  <p
                      class="section-error-message"
                      v-if="items.qty > items.max_qty"
                  >
                    Requested quantity not available.
                  </p>
                  <div class="price" v-if="items.selling_price != items.price">
                    <p>
											<span
                          class="old-price"

                      >{{ items.price | formatMoney }}</span>
                      <span
                          class="price"

                      >{{ items.selling_price | formatMoney }}</span>
                      <span
                          class="discount_percent font-bold">{{
                          $root.percentOff(items.price, items.selling_price)
                        }}</span
                      >
                    </p>
                  </div>
                  <div class="price" v-else>
                    <p>
											<span
                          class="price"

                      >{{ items.selling_price | formatMoney }}</span>
                    </p>
                  </div>

                  <p v-if="items.size && items.size !='null'">
                    <span class="font-medium">SIZE : </span>
                    <span v-text="items.size"></span>
                  </p>
                  <p>
                    <span class="font-medium">QTY : </span>
                    <span v-text="items.qty"></span>
                  </p>
                  <!-- remove-cart -->
                  <a
                      href="#"
                      @click.prevent="deleteEvent(items, index)"
                      title="Remove"
                      class=""
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i
                    ><span> Remove </span></a
                  >
                </div>
              </div>
            </li>
          </ol>
          <div class="actions">
            <router-link :to="{ name: 'cart' }" class="checkout__new">
              View and Edit Cart
            </router-link>
            <router-link :to="{ name: 'Checkout' }" class="checkout">
              Checkout
            </router-link>
          </div>
        </div>
      </div>
      <div
          class="minicart-content"
          v-bind:class="[this.$root.minicart ? '' : 'active']"
          v-else
      >
        <div class="block-content text-center">
          <button
              type="button"
              class="action close"
              title="Close"
              @click="$root.minicart = false"
          >
            <span class="fa fa-close"></span>
          </button>
          <img
              src="/img/emptyCart.png"
              class="img-fluid"
              style="max-width: 200px"
              alt=""
          />
          <p class="mt-3">Ohh.. Your cart is empty</p>
        </div>
      </div>
    </div>

  </div>
</template>
<style>
/* .menu .link:nth-child(even){
          display: none;
        } */

.newStoreSticky {
  background: #9f0a0e;
}

.newStoreSticky .sortLink .link > a {
  color: #fff
}

.newStoreSticky .sortLink .link > .router-link-active {
  color: var(--main-color) !important;
  background: #fff;
}

.newStoreSticky .sortLink .link > a:hover {
  color: var(--main-color) !important;
}

/* .subMenu.fashion{
  background-image: url(/img/Fashion-1.jpg);
  background-position: top 20px right 20px;
  background-repeat: no-repeat;
} */
.pointerEvent {
  pointer-events: none !important;
}

.menuImage {
  width: 50%;
}

.fashion .menuImage {
  width: 50%;
}

.beauty .menuImage {
  width: 50%;
  display: inherit;
}

.grocery .menuImage {
  width: 50%;
}

.electronics .menuImage {
  width: 50%;
}

.homeandliving .menuImage {
  width: 50%;
}
.pharmacy .menuImage {
  width: 50%;
}
.petcare .menuImage {
  width: 50%;
}

.fashion .menuImageFashion {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.electronics .menuImageElectronics {

  display: inline-flex;
}

.homeandliving .menuImageHomeliving {

  display: inline-flex;
}
.pharmacy .menuImagePharmacy {

  display: inline-flex;
}
.petcare .menuImagePetcare {

  display: inline-flex;
}

.sports .menuImageSport {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.books .menuImageGift {
  display: block;
}

.fashion .menuImageFashion img:first-child, .sports .menuImageSport img:first-child, .beauty .menuImageBeauty img:first-child {
  margin-right: 10px;
}

.beauty .menuImageBeauty {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.grocery .menuImageFood {

  display: block;
}

.menuImageFashion, .menuImageBeauty, .menuImageFood, .menuImageElectronics, .menuImageSport, .menuImageGift, .menuImageHomeliving, .menuImagePharmacy, .menuImagePetcare {
  display: none;
}


/* .subMenu.grocery{
  background-image: url(/img/foods-and-grocery-1.jpg);
  background-position: top 20px right 20px;
  background-repeat: no-repeat;

}
.subMenu.beauty{
  background-image: url(/img/Beauty-&-Wellness2.jpg);
  background-position: top 20px right 20px;
  background-repeat: no-repeat;
  background-size: auto 90%;
} */


.menuHeight {
  /* height: 28px; */
  position: fixed;
  top: 70px;
  width: 100%;
  z-index: 98;
}

.locationDrop {
  min-width: 300px;
  display: block;
  margin-top: 30px;
  border-radius: 0px;
  padding: 0;
  max-height: 400px;
  /* overflow-y: auto; */
  border: none;
  box-shadow: 0 0px 10px rgb(0 0 0 / 24%);
  /* overflow: hidden;  */
  border-radius: 5px;
}

.locationDrop::before {
  content: '';
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  position: absolute;
  left: 20%;
  top: -10px;
  transform: rotate(45deg);
}

.locationDrop .searchLocation {
  width: 100%;
  border: 1px solid #f5f0f0;
  padding: 10px 6px;
  font-family: "lhmRegular";
  border-radius: 0;
  font-size: 14px;
}

.locationDrop .searchLocation:focus {
  border: 1px solid #ccc;
  outline: none;
  box-shadow: none;
}

.locationDrop li {
  padding: 14px 10px;
  border-bottom: 1px solid #f5f0f0;
  display: inline-block;
  width: 100%;
  cursor: pointer;
}

.locationDrop li:first-child {
  border-bottom: none;
}

/* .locationDrop li:hover {
    background-color: #f8f8f8;
  } */
.locationDrop small {
  font-size: 10px;
  text-transform: uppercase;
  width: 100%;
  display: block;
  font-family: 'lhmRegular';
  padding-left: 10px;
}

.locationDrop li a {
  font-size: 14px;
  text-transform: none;
  color: #626262;
  font-family: "lhmRegular";
  display: block;
}

/* .getLocation a {
    color: var(--main-color) !important;
  } */
.getLocation a {
  background-color: #EEEEEE;
  display: inline-block !important;
  width: 100%;
  padding: 10px;
}

.getLocation {
  padding-top: 0 !important;
}

.getLocation h4 {
  font-size: 16px;
}

.getLocation a:hover h4 {
  color: var(--main-color);
}

.getLocation img {
  width: 20px;
  margin-top: 3px;
  margin-right: 2px;
}

.categoryLink {
  font-size: 16px;
  line-height: 20px;
  font-family: "lhmRegular";
  color: var(--font-dark-blue);
  text-transform: capitalize;
}

.categoryLink span {
  color: var(--main-color);
}

.search__products.matching-store a {
  font-size: 11px;
}

.search__products a {
  font-size: 13px;
  /* line-height: 36px; */
  font-family: "lhmSemiBold";
  color: #626262;
  display: block;
  padding: 5px 0px;
  margin-top: 0px !important;
}

.search__products a b.search-text {
  color: #282c3f;
}

.search__products a b {
  font-family: 'lhmBold';
}

.search-sidebar .categoryLink:first-child {
  margin-top: 0 !important;
}

.search__products .router-link-active {
  padding: 0;
}

/* .searchIcon::before {
        position: absolute;
        right: 23px;
        top: -16px;
        background-color: transparent;
        cursor: pointer;
        border: none;
        font-size: 0px;
        padding: 0px;
        width: 30px;
        width: 12px !important;
        height: 12px !important;
        font-size: 22px;
        color: #000;
        content: "\e801";
        font-family: "fontello";
      }*/
.searchIcon.activeSearch::before {
  content: "x" !important;
  font-family: "lhmRegular";
  top: 5px;
  font-size: 20px;
  z-index: 7;
  font-weight: 100;
}

.loginDetail {
  position: absolute;
  right: 0;
  z-index: 1;
  background: #fff;
  min-width: 300px;
}

.close {
  position: absolute;
  right: 32px;
  top: 32px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}

.search__products p {
  font-size: var(--font-size-regular) !important;
  /* line-height: 16px; */
  /* font-size: 10px; */
  color: #ba2126 ;
  margin-bottom: 2px;
  text-transform: uppercase;
  font-family: 'lhmBold';
  padding-top: 8px;
}

.close:hover {
  opacity: 1;
}

/* .close:before, .close:after {
                      position: absolute;
                      left: 15px;
                      content: ' ';
                      height: 15px;
                      width: 2px;
                      background-color: #333;
                    }
                    .close:before {
                      transform: rotate(45deg);
                    }
                    .close:after {
                      transform: rotate(-45deg);
                    } */

.dropdowmMenu {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

a.link.dropdownMenu {
  padding: 1.7rem;
}

.subMenu .newUlDrop > ul {
  -webkit-column-count: 3;
  -moz-column-count: 3;
  column-count: 3;
  -webkit-column-gap: 1em;
  -moz-column-gap: 1em;
  column-gap: 1em;
  margin: 1.5em;
  padding: 0;
  -moz-column-gap: 1.5em;
  -webkit-column-gap: 1.5em;
  column-gap: 1.5em;
  display: block;
}

.subMenu .newUlDrop {
  display: flex;
  position: fixed;
  background-color: #fff;
  left: 5%;
  top: 96px;
  width: 90%;
  /* width: calc(100% - 200px); */
  /* height: 0; */
  /* background: linear-gradient(to right, #fff 0%,#fff 25%,#f9f9f9 25%,#f9f9f9 50%, #FFF 50%,#fff 75%,#f9f9f9 75%,#f9f9f9 100%); */
  min-width: 440px;
  overflow: hidden;
  margin-top: 0;
  padding: 10px 10px !important;

  /* display: none; */
}

.subMenu {
  opacity: 0 !important;
  visibility: hidden !important;
  box-shadow: 2px 4px 10px rgb(0 0 0 / 24%), inset 0px 2px 3px -1px rgb(0 0 0 / 24%);
  transition: visibility 0.1s, opacity 0.1s;
  transition-delay: 0s;
}
 
.link > a.dropdownChild {
  position: relative;
  display: inline-flex;
  text-align: center;
  width: max-content
}

.link > a.dropdownChild:hover::after {
  width: 100%;
}

.link > a.dropdownChild::after {
  content: '';
  position: absolute;
  width: 0;
  height: 4px;
  left: 0;
  bottom: -4px;
  background-color: #000;
  z-index: 99;
  transition-delay: 4s;
  transition: width .4s ease-in-out;
}

.dropdownChild:hover + .subMenu {
  /* display: block; */
  height: auto;
  opacity: 1 !important;
  visibility: visible !important;
  transition-delay: .25s;
}

.dropdownChild + .subMenu:hover {
  opacity: 1 !important;
  visibility: visible !important;
  display: block;
}

.menu .dropdownMenu .menuBackground {
  /* display: none; */
  background-color: rgba(0, 0, 0, .3);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 96px;
  opacity: 0 !important;
  visibility: hidden !important;

}

.menu .dropdownMenu .menuBackground:hover {
  display: none !important;
}

.menu .dropdownMenu:hover .menuBackground {
  /* display: block; */
  opacity: 1 !important;
  visibility: visible !important;
  transition-delay: .25s;
}

.dropdownMenu .lastLink {
  justify-content: flex-start;
  text-decoration: none;
  list-style: none;
  color: var(--font-dark-color) !important;
}

.subLink > a {
  font-family: 'lhmBold';
  display: inline-block;
  text-transform: uppercase !important;
  font-size: 12px !important;
}

.subLink {
  width: 100%;
}

ul.lastmenu {
  padding: 0px;
}

.tempClass {
  opacity: 0 !important;
  visibility: hidden !important;
  display: none !important;
}

.subLink a,
.lastMenu a {
  color: var(--font-dark-blue);
  font-size: var(--font-size-regular);
  line-height: 20px;
  margin-bottom: 0px;
  text-decoration: none;
  text-transform: capitalize;
  overflow: auto;
  line-height: 23px;
}

/* .dropdownMenu .subMenu{
          flex-flow: column wrap;
          height: 400px;
          column-count: 4;
        } */
.subMenu.grocery .subLink {
  -webkit-column-break-inside: unset;
  page-break-inside: unset;
  -moz-column-break-inside: avoid;
  break-inside: unset;
}

.subLink {
  font-family: "lhmSemiBold";
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
}

.lastLink {
  font-family: 'lhmRegular';
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
}

.lastMenu {
  list-style: none;
  text-decoration: none;
  padding-inline-start: 0px !important;
}

.product .router-link-active {
  padding: 0px;
  background: none;
}

a.font-medium.router-link-active {
  text-decoration: none;
  color: #626262;
}

.minicart-items li .product-item-details p {
  padding: 0px !important;
}

.minicart-content .actions .checkout {
  border: 1px solid var(--main-color);
  background: var(--main-color);
  color: #fff !important;
}

.menuContainer {
  background: #9f0a0e;
  position: relative;
  transition: all 0.5s ease-in-out;
  z-index: 9;
  box-shadow: 0px 0px 5px 0 #363636;
  top: -15px;
  height: 41px;
}

.menuContainer .link {
  font-family: 'lhmBold';
  font-size: var(--font-size-regular);
  color: var(--font-dark-blue);
}

.menu {
  display: flex;
  position: relative; 
  max-width: 80%; justify-content: center;
  margin: auto;
}

.link.router-link-active {
  padding: 0px 0.5rem;
}

.subMenu .subLink .router-link-active {
  padding: 0 !important;
}

.link {
  font-family: "lhmBold";
  text-decoration: none;
  color: #626262;
  text-transform: capitalize;
  margin: 0px 7px;
  font-size: 14px;
  line-height: 8px;
}

.link:hover {
  transition: all 0.2s ease-in-out;
  color: var(--main-color);
  /* background: #ffffff; */
}

.menuContainer.sticky,
.sortLink.sticky {
  background-color: #ffffff;
  z-index: 3;
  transition: all 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  max-height: 71px;
  box-shadow: none;
  padding: 5px;
  position: fixed;
}

.menuContainer.sticky .icons.visible > .badge {
  top: -10px;
  right: 40px;
}

.menuContainer.sticky .menu {
  margin: 0px !important;
}

.visible {
  display: none;
}

.menuContainer.sticky .visible {
  display: flex;
  height: 30px;
  margin-right: 20px;
  align-items: center;
  transition: all 0.5s ease-in-out;
}

.menuContainer.sticky .location.visible {
  display: none;
}

.menuContainer.sticky > img {
  height: 50px !important;
  position: absolute;
  left: 20px;
  cursor: pointer;
}

.menuContainer.sticky .menu {
  align-items: center;
}

.sticky {
  position: sticky;
  top: 0;
  width: 100%;
  animation: fadeIn 0.5s ease-in both;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.05);
}

.menuImageRightSection {
  width: 50%;
  text-align: right;
  padding-right: 20px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.minicart {
  position: absolute;
  right: 0;
  z-index: 99;
}

.stickyStore #All .sort {
  position: fixed;
  top: 0;
  z-index: 99;
  background: #fff;
  border: none;
  color: #333;
  left: 0px;
  height: 55px;
  font-family: "lhmBold";
  animation: storesAnimation 0.3s ease-out;
}

@keyframes storesAnimation {
  0% {
    transform: translate3d(0, -100%, 0);
  }
}

/* Responsive  */
@media screen and (max-width: 767px) {
  #menuContainer .menu {
    display: none !important;
  }

  .navigation {
    display: flex !important;
  }

  .navigation .input {
    display: none;
  }

  .menuContainer {
    display: none;
  }

  .menuContainer.sticky {
    display: none;
  }
}
</style>
<script>

import Logo from "../Header/Logo";
import axios from "axios";

export default {
  components: {
    Logo,
  },
  watch: {
    $route() {
      this.isChangedEvent = true
      setTimeout(() => {
        this.isChangedEvent = false
      }, 100);
    }
  },
  data() {
    return {
      isChangedEvent: false,
      activeName: "brands",
      search: "",
      hideMenu: false,
      stores: null,
      products: null,
      sameLinkmenu: false,
      sectionActive: "",
      XPosition: "",
      YPosition: "",
    };
  },

  methods: {
    checkStore(store,value){
      let count = 0
			for (let index = 0; index < this.$root.cart_product.length; index++) {
          if (this.$root.cart_product[index].store_id == store) {
             count = count +1
          }
        }
        if (count>0) {
          return value
        } else {
          
          let finalStores = value -1;
          value = finalStores
          this.$root.numberOfStores = value;
          return value
        }
			},
    hideMenuHandler(e) {
      this.XPosition = e.clientX;
      this.YPosition = e.clientY;
      this.hideMenu = true;
    },
    hideMenuHandlerN() { 
      this.hideMenu = true;
      setTimeout(function () {
        this.hideMenu = false;            
       }, 1000)
    },
    hideMenuFunction(e) {
      if(e.clientX != this.XPosition && e.clientY != this.YPosition){
        if (this.hideMenu == true) {
          this.hideMenu = false;
        }
      }
    },
    closeMiniCart() {
      if (this.$root.minicart = false) {
        this.$root.minicart = true;
      }
      // alert('asdfasdf')
    },
    pushToHome() {
      this.$router.push({path: '/'});
    },
    goToAccount() {
      // alert('asdfa');
      this.$router.push({path: '/account-dashboard.html'})
    },
    toggleLogin() {
      
      this.$root.login_popup = true;
    },
    navLink() {
      this.hideMenu = true;
    },
    pointerEvent() {
      let element = document.getElementsByClassName('pointerEvent')
      element.pointerEvent = 'auto'
    },
    removeAnd(menu) {

      return menu.replace("and", "&")
    },
    formatPrice(value, precision = false) {
      let val;

      if (precision) val = (value / 1).toFixed(2).replace(",", ",");
      else val = (value / 1).toFixed(0).replace(",", ",");

      return `<span>&#8377;</span> ${val
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          .replace(".00", "<small>.00</small>")} `;
    },

    toggleSearch() {
      this.isSearchActive = !this.isSearchActive;
      this.isSearch = false;
      this.search = "";
    },

    closeLoginDetail() {
      this.$root.login_detail = false;
    },
    wishlist() {
      this.$router.push({name: "Wishlist"});
    },
    // toggleLoginDetail() {
    // 	this.$router.push({ name: "dashboard" });
    // },
    get_cart: function () {
      this.$root.pcart = $cookies.get(
          window.location.hostname.substring(10, 4) + "_cart",
          ""
      );
      if (
          this.$root.pcart != null &&
          this.$root.pcart != "" &&
          this.$root.pcart != "undefined"
      ) {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("pcart", this.$root.pcart);
        form.append("cart_session", this.$root.cart_session);
        axios
            .post(this.$root.cart_api + "/cart/get-cart", form)
            .then((response) => {
              if (response.data.success === true) {

                this.$root.shipping_charge = response.data.shippingCharge
                this.$root.cart_total = response.data.grandTotal
                this.$root.cart_subtotal = response.data.subTotal
                this.$root.cart_netAmount = response.data.netAmount
                this.$root.discount_amount = response.data.discountAmount

                if (this.$root.pcart === null) {
                  this.$root.pcart = response.data.pcart;

                }
                if (response.data.data.length > 0) {
                  let ProductsArray = [];
                  // Sorting Products array according to SKU

                  response.data.data.forEach((cart) => {
                    ProductsArray = [...ProductsArray, ...cart.products]

                    if (cart.cookieDelete === 1) {
                      $cookies.set(window.location.hostname.substring(10, 4) + "_cart", "");
                      this.$root.pcart = "";
                    }


                  });

                  this.$root.cart_product = ProductsArray;


                } else {
                  this.$root.cart_product = []
                  this.$root.shipping_charge = response.data.shippingCharge
                  this.$root.cart_total = response.data.grandTotal
                  this.$root.cart_subtotal = response.data.subTotal
                  this.$root.cart_netAmount = response.data.netAmount
                  this.$root.discount_amount = response.data.discountAmount


                }


                this.$root.page_loader = false
                if (this.$root.address.length != 0) {
                  for (let i = 0; i < this.$root.address.length; i++) {
                    if (i == 0) {
                      this.$root.address_id = this.$root.address[i].id * 1;
                      this.$root.select_address_no = i;
                    }
                  }
                }
              } else {
                this.$root.page_loader = false;
                this.$root.error_message = response.data.message;
                if (response.data.cart_session_status == false) {
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cs",
                      "",
                      "1y"
                  );
                  this.$root.customer_id = "";
                  this.$root.customer_session = "";
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      "",
                      "1y"
                  );
                  $cookies.set(
                      window.location.hostname.substring(10, 4) + "_carts",
                      "",
                      "1y"
                  );
                  this.$root.pcart = "";
                  this.$root.cart_session = "";
                  this.$root.cart_product = [];
                }
              }
            })
            .catch((error) => {
              this.$root.page_loader = false;
              if (error.message === "Network Error") {
                this.$root.error_message =
                    "Oops there seems to be some Network issue, please try again.";
              }
              // window.scrollTo(0, 0);
            });
      }
    },

    minicart_show_hide() {
      this.$root.minicart = !this.$root.minicart
    },
    deleteEvent: function (product, index) {
      this.$root.minicart = true
      // console.log(index);
      // this.$gtm.trackEvent({
      //     event: 'removeFromCart',
      //     category: 'cart',
      //     action: 'Remove From Cart',
      //     label: name,
      //     cart: {
      //         remove: {
      //             product: [{
      //                 name: this.$root.cart_product[index].name,
      //                 id: this.$root.cart_product[index].master_sku,
      //                 price: this.$root.cart_product[index].selling_price,
      //                 category: '',
      //                 variant: this.$root.cart_product[index].size,
      //                 quantity: this.$root.cart_product[index].qty
      //             }]
      //         }
      //     }
      // });
      this.$root.error_message = "";
      this.$root.success_message = "";
      // this.$root.page_loader = true;
      var form = new FormData();
      form.append("pcart", this.$root.pcart);
      form.append("cart_id", product.order_quote_id);
      form.append("product_id", product.variant_id);
      axios
          .post(this.$root.cart_api + "/product/remove-product", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.page_loader = false;
              this.$toast.error("Product removed successfully", {
                position: "top",
                duration: 4000,
              });

              // this.$root.success_message = response.data.message;
              if (response.data.data.length == 0) {
                this.$root.cart_product = [];
                this.$root.pcart = null;
              } else {
                if (index > -1) {
                  this.$root.cart_product.splice(index, 1);
                  if (this.$root.numberOfStores != 0) {
                    this.checkStore(product.store_id,this.$root.numberOfStores)
                    //this.$root.numberOfStores = this.$root.numberOfStores - 1;
                  }
                }
                // this.$root.cart_product.slice(index,1)
                // console.log(response.data.data);
                // this.$root.cart_product = [...response.data.data]
              }
              // this.$root.cart_product = response.data.data.products;

              //Code for multi cart add

              // Commented for remove check on 15th jan

              // if (
              // 	this.$root.pcart === null ||
              // 	this.$root.pcart != response.data.data.pcart
              // ) {
              // 	this.$root.pcart = response.data.data.pcart;
              // }

              // ends

              if (response.data.data.length > 0) {
                //Products Array
                //   let ProductsArray = []
                //   // Sorting Products array according to SKU
                this.$root.cart_total = 0;
                this.$root.cart_subtotal = 0;
                this.$root.cart_netAmount = 0;
                response.data.data.forEach((products) => {
                  this.$root.cart_total =
                      this.$root.cart_total + products.grand_total;
                  this.$root.cart_subtotal =
                      this.$root.cart_subtotal + products.order_subtotal;
                  this.$root.cart_netAmount =
                      this.$root.cart_netAmount + products.net_amount;
                });

                //   // Modifying Price and Quantity accroding to SKU
                //   let data = []
                //   let price = 0
                //   ProductsArray.forEach((ele,index)=>{
                //       console.log(ele);
                //       console.log("break");
                //    let qty=0
                //       ele.forEach(product=>{
                //           qty = qty + product.qty
                //            ele[0]["qty"] = qty
                //       })
                //       data.push(ele[0])
                //   })
                //   this.$root.cart_product = data
              } else {
                (this.$root.cart_total = response.data.data.grand_total),
                    // net_amount:response.data.data.net_amount,
                    (this.$root.cart_subtotal = response.data.data.order_subtotal);
                // products = response.data.data.products
                // this.$store.dispatch('getAmount', amount)
                //  this.get_cart()
                // this.$root.cart_product = response.data.data.products
                //  this.$store.dispatch('getCart', response.data.data.products)
              }

              if (response.data.data.cart_session) {
                this.$root.pcart = response.data.data.pcart;
                this.$root.thankyou_cart = response.data.data.pcart;
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    response.data.data.pcart,
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    response.data.data.cart_session,
                    "1y"
                );
                this.$root.cart_session = response.data.data.cart_session;
              }
              this.free_offer = false;
              for (let e = 0; e < this.$root.cart_product.length; e++) {
                for (let i = 0; i < this.free_offer_sku.length; i++) {
                  if (
                      this.free_offer_sku[i] ==
                      this.$root.cart_product[e].master_sku
                  ) {
                    this.free_offer = true;
                  }
                }
              }
              // this.$root.cart_total = response.data.data.grand_total;
              // this.$root.cart_subtotal = response.data.data.order_subtotal;
              // this.$root.discount_amount = response.data.data.discount_amount;
              this.$root.discount_code = response.data.data.discount_code;
              // this.net_amount = response.data.data.net_amount;
              this.cod_charges = response.data.data.cod_charge;
              this.shipping_charges = response.data.data.shipping_charges;
              this.applied_coupon = response.data.data.discount_code;
              this.$root.error_message = "";
            } else {
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              if (response.data.cart_session_status == false) {
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_customer",
                    "",
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cs",
                    "",
                    "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    "",
                    "1y"
                );
                $cookies.set(
                    window.location.hostname.substring(10, 4) + "_carts",
                    "",
                    "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                  "Oops there seems to be some Network issue, please try again.";
            }
            // window.scrollTo(0, 0);
          });
    },
  },

  mounted() {
    // $('.dropdownMenu .dropdownChild').hover(function(){
    // 	console.log('hovered');
    // 	$(this).siblings('.subMenu').toggleClass('showDrop');
    // });
    let windowWidth = "";
    window.addEventListener("resize", () => {
      windowWidth = window.innerWidth;
    });

    window.addEventListener("scroll", function (e) {
      let category = document.getElementsByClassName("category newStoreSticky");
      let menu = document.getElementsByClassName("menuHeight");
      let nearby = document.getElementById("nearby");
      // console.log(nearby.offsetTop);
      if (category && nearby) {
        if (window.pageYOffset < 570 || window.pageYOffset > 4150) {
          category[0].classList.remove("d-block");
          var prevScrollpos = window.pageYOffset;
          window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos < currentScrollPos) {
              // alert("up scroll");
              if (category[0]) {
                category[0].classList.add("d-block");
              }
            } else {
              if (category[0]) {
                category[0].classList.remove("d-block");
              }
              // alert("down scroll");
            }
            prevScrollpos = currentScrollPos;
          };
        } else {
          category[0].classList.add("d-block");
        }
        // if (window.pageYOffset > nearby.offsetTop) {
        // 	nearby.classList.add("stickyStore");
        // } else {
        // 	nearby.classList.remove("stickyStore");
        // }
      }
    });
  },
};
</script>
